import React from 'react';

const EmployeeSalaryReportHeader = () => (
    <h1>Employee Salary Report</h1>
);

export default EmployeeSalaryReportHeader;
